var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuggestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 13H3M13 1.75V3M23 13H24.25M5 5L5.875 5.875M21 5L20.125 5.875M10.125 19.25H15.875M9.25 18C8.20059 17.2129 7.42542 16.1156 7.03429 14.8635C6.64316 13.6114 6.65591 12.268 7.07073 11.0236C7.48555 9.77913 8.2814 8.69674 9.34556 7.92974C10.4097 7.16273 11.6882 6.75 13 6.75C14.3118 6.75 15.5903 7.16273 16.6544 7.92974C17.7186 8.69674 18.5145 9.77913 18.9293 11.0236C19.3441 12.268 19.3568 13.6114 18.9657 14.8635C18.5746 16.1156 17.7994 17.2129 16.75 18C16.262 18.4831 15.8945 19.0743 15.6773 19.7258C15.4602 20.3773 15.3994 21.0707 15.5 21.75C15.5 22.413 15.2366 23.0489 14.7678 23.5178C14.2989 23.9866 13.663 24.25 13 24.25C12.337 24.25 11.7011 23.9866 11.2322 23.5178C10.7634 23.0489 10.5 22.413 10.5 21.75C10.6006 21.0707 10.5398 20.3773 10.3227 19.7258C10.1055 19.0743 9.73804 18.4831 9.25 18Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_707_536",
    x1: 13,
    y1: 1.75,
    x2: 13,
    y2: 24.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3612C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A095D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuggestion);
export default __webpack_public_path__ + "static/media/IconSuggestion.ff11320dfce3caaff0113079c4b53eb1.svg";
export { ForwardRef as ReactComponent };